import service from '@/store/services/locations-service';

const state = {
    list: {},
    location: {},
    meta: {},
    alert: {
        id: null,
        message: '',
        type: "warning"
    },
};

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
    SET_RESOURCE: (state, location) => {
        state.location = location;
    },
    SET_META: (state, meta) => {
        state.meta = meta;
    },
    SET_ALERT: (state, alert) => (state.alert = alert),
};

const actions = {
    list({ commit, dispatch }, params) {
        return service.list(params)
            .then(({ list, meta }) => {
                commit('SET_LIST', list);
                commit('SET_META', meta);
            });
    },

    get({ commit, dispatch }, params) {
        return service.get(params)
            .then((role) => { commit('SET_RESOURCE', role); });
    },

    add({ commit, dispatch }, params) {
        return service.add(params)
            .then((location) => { commit('SET_RESOURCE', location); });
    },

    update({ commit, dispatch }, params) {
        return service.update(params)
            .then((location) => { commit('SET_RESOURCE', location); });
    },

    destroy({ commit, dispatch }, params) {
        return service.destroy(params);
    },

    setAlert({ commit, dispatch }, alert) {
        setTimeout(()=>{
            alert.message = '';
            alert.id = null;
        }, 8000)
        commit('SET_ALERT', alert);
    },
};

const getters = {
    list: state => state.list,
    listTotal: state => state.meta.page.total,
    location: state => state.location,
    dropdown: (state) => {
        return state.list.map(location => ({
            id: location.id,
            name: ((location.name 
                + ' (' + (location.street ? location.street + ' ' : '')
                + (location.house_number || location.apartment_number ? (location.apartment_number ? location.house_number +'/'+ location.apartment_number : location.house_number) + ', ' : '')
                + location.post_code +' '+ location.city + ')').length > 50 ? 
                (location.name 
                    + ' (' + (location.street ? location.street + ' ' : '')
                    + (location.house_number || location.apartment_number ? (location.apartment_number ? location.house_number +'/'+ location.apartment_number : location.house_number) + ', ' : '')
                    + location.post_code +' '+ location.city + ')').slice(0, 50) + '...' :
                (location.name 
                    + ' (' + (location.street ? location.street + ' ' : '')
                    + (location.house_number || location.apartment_number ? (location.apartment_number ? location.house_number +'/'+ location.apartment_number : location.house_number) + ', ' : '')
                    + location.post_code +' '+ location.city + ')')
                )
        }));
    },
    alert: state => state.alert,
};

const locations = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default locations;